import {BasicsClass} from "@/common/BasicsClass";

export default class InventoryManageAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getList', {
            url: '/goods/inventory',
            name: 'list',
            label: '列表'
        }],
        // ['category', {
        //     url: '/goods/category',
        //     name: 'goodsCategory',
        //     label: '商品分类'
        // }],
        // ['add', {
        //     url: '/goods/add',
        //     name: 'add',
        //     label: '添加'
        // }],
        // ['save', {
        //     url: '/goods/save',
        //     name: 'save',
        //     label: '修改'
        // }],
        // ['delete', {
        //     url: '/goods/delete',
        //     name: 'delete',
        //     label: '删除'
        // }],
        // ['ossSts', {
        //     url: '/oss/sts',
        //     name: 'ossSts',
        //     label: '上传'
        // }],
        // ['categoryLists', {
        //     url: '/category/lists',
        //     name: 'categoryLists',
        //     label: '商品分类列表'
        // }],
        ['export', {
            url: '/goods/exportInventory',
            name: 'export',
            label: '导出'
        }],
    ])


    //商品列表
    public inventoryList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls
        const url = apiUrls.get('getList').url
        this.BasicPost(
            url,
            {
                ...params,
            },
            false,
            false,
            false,
            successCb,
            failCb,
            showLoading
        );
    }

    //商品分类
    // public goodscategory(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls
    //     const url = apiUrls.get('category').url
    //     this.BasicPost(
    //         url,
    //         {
    //             ...params,
    //         },
    //         false,
    //         false,
    //         false,
    //         successCb,
    //         failCb,
    //         showLoading
    //     );
    // }

    // //添加商品
    // public goodsadd(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls
    //     const url = apiUrls.get('add').url
    //     this.BasicPost(
    //         url,
    //         {
    //             ...params,
    //         },
    //         false,
    //         false,
    //         false,
    //         successCb,
    //         failCb,
    //         showLoading
    //     );
    // }

    // //修改商品
    // public goodssave(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls
    //     const url = apiUrls.get('save').url
    //     this.BasicPost(
    //         url,
    //         {
    //             ...params,
    //         },
    //         false,
    //         false,
    //         false,
    //         successCb,
    //         failCb,
    //         showLoading
    //     );
    // }

    // //删除商品
    // public goodsdelete(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls
    //     const url = apiUrls.get('delete').url
    //     this.BasicPost(
    //         url,
    //         {
    //             ...params,
    //         },
    //         false,
    //         false,
    //         false,
    //         successCb,
    //         failCb,
    //         showLoading
    //     );
    // }
    // //上传
    // public ossSts(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls
    //     const url = apiUrls.get('ossSts').url
    //     this.BasicPost(
    //         url,
    //         {
    //             ...params,
    //         },
    //         false,
    //         false,
    //         false,
    //         successCb,
    //         failCb,
    //         showLoading
    //     );
    // }


    // public getCategoryLists(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls
    //     const url = apiUrls.get('categoryLists').url
    //     this.BasicPost(
    //         url,
    //         {
    //             ...params,
    //         },
    //         false,
    //         false,
    //         false,
    //         successCb,
    //         failCb,
    //         showLoading
    //     );
    // }

    public export(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls
        const url = apiUrls.get('export').url
        this.BasicPost(
            url,
            {
                ...params,
            },
            false,
            false,
            false,
            successCb,
            failCb,
            showLoading
        );
    }


}
